import React from 'react'
import styled from '@emotion/styled'
import { withTheme } from 'emotion-theming'
import { object, string } from 'prop-types'

// Import utils
import { makeImgResizerUrl } from '@jelly/utils'

// Import Components
import { PriceQuotes as PriceQuotesSvg } from '@jelly/components'
import { Link } from '@jelly/ui'

// styled components
const PriceQuotesWrapper = styled.div`
	height: 100%;
	width: 100%;
	position: relative;
	display: flex;
	flex-direction: column;
	margin: auto;

	${({ theme }) => theme.MQ.M} {
		max-height: 600px;
		min-height: 600px;
		flex-direction: row;
	}
`
const ContentWrapper = styled.div`
	display: none;

	${({ theme }) => theme.MQ.M} {
		width: 50%;
		display: inline-block;
		vertical-align: middle;
		height: 600px;
		max-height: 600px;
	}
`
const MobileContentWrapper = styled.div`
	display: block;
	vertical-align: middle;
	height: 400px;
	padding: 40px;
	${({ theme }) => theme.MQ.M} {
		display: none;
	}
`
const ImageWrapper = styled.div`
	background-position: 0 5%;
	background-repeat: no-repeat;
	background-size: cover;
	display: block;
	height: 300px;
	width: 100%;

	&.lazyloaded {
		background-image: url(${({ image }) => image});
	}

	${({ theme }) => theme.MQ.M} {
		background-position: 0% 0%;
		background-repeat: no-repeat;
		background-size: cover;
		display: inline-block;
		width: 50%;
		height: 599px;
	}
`
const Title = styled.div`
	font-size: 21px;
	font-weight: 500;
	color: ${({ theme }) => theme.colors.navy};

	${({ theme }) => theme.MQ.M} {
		font-size: 34px;
		font-weight: 500;
	}
`
const Description = styled.p`
	${({ theme }) => theme.text.bodyLarge};
	color: ${({ theme }) => theme.colors.darkGrey};
	padding-bottom: 20px;
	margin: 0;

	${({ theme }) => theme.MQ.M} {
		width: 80%;
		max-height: 250px;
	}
`
const QuoteButton = styled(Link)`
	${({ theme }) => theme.buttons.default};
`
const DesktopContentWrapper = styled.div`
	${({ theme }) => theme.MQ.M} {
		padding: 80px 40px 40px 90px;
	}

	${({ theme }) => theme.MQ.MAX} {
		padding: 80px 40px 40px 160px;
	}

	@media (min-width: 768px) and (max-width: 780px) {
		padding: 40px 40px 40px 90px;
	}
`

PriceQuotes.propTypes = {
	description: string.isRequired,
	cta: string.isRequired,
	image: string.isRequired,
	path: string.isRequired,
	theme: object.isRequired,
	title: string.isRequired,
}

/**
 * This is the Price Quotes section for the review landing page
 * Contains a short description and links to price-quotes page
 */
function PriceQuotes({ description, cta, image, path, theme, title }) {
	const priceQuotesImage = makeImgResizerUrl({ src: image, method: 'rc', w: 850, h: 600 })
	return (
		<PriceQuotesWrapper>
			<ContentWrapper>
				<DesktopContentWrapper>
					<PriceQuotesSvg stroke={theme.colors.navy} width="40px" height="60px" />
					<Title>{title}</Title>
					<Description>{description}</Description>
					<QuoteButton href={path}>{cta}</QuoteButton>
				</DesktopContentWrapper>
			</ContentWrapper>
			<ImageWrapper image={priceQuotesImage} className="lazyload" />
			<MobileContentWrapper>
				<PriceQuotesSvg stroke={theme.colors.navy} width="40px" height="60px" />
				<Title>{title}</Title>
				<Description>{description}</Description>
				<QuoteButton href={path}>{cta}</QuoteButton>
			</MobileContentWrapper>
		</PriceQuotesWrapper>
	)
}
export default withTheme(PriceQuotes)
